export type AchievementType = 'diligent-student' | 'geography-expert' | 'world-traveler' | 'ocean-explorer';

export function assertAchievementType(type: string): asserts type is AchievementType {
    if (type !== 'diligent-student' && type !== 'geography-expert' && type !== 'world-traveler' && type !== 'ocean-explorer') {
        throw new Error(`Invalid AchievementType: ${type}`);
    }
}
